import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {message, Spin} from "antd";
import {useIntl} from "react-intl";
import beApis from "src/util/apis/be";

import "./index.css";
import ToastSuccess from "../../../assets/svg/ToastSuccess";
import IntlMessages from "../../../util/IntlMessages";

const DeviceApproved = ({id}) => {
  const [loading, setLoading] = useState(true);
  const [approved, setApproved] = useState(false);

  const intl = useIntl();
  const csSelected = useSelector(({cs}) => cs.csSelected);

  useEffect(() => {
    const values = {
      is_approved: true,
    }

    setLoading(true);

    beApis.updateAllowedDeviceByQuickLink(csSelected.host, id, values)
      .then((resp) => {
        setLoading(false);
        setApproved(true);

        // 성공 메시지도 함께 표시하고 싶다면 주석을 해제하세요
        // message.success({
        //   content: intl.formatMessage({id: 'vlink.settings.access.approved'}),
        //   icon: <ToastSuccess/>,
        // });
      })
      .catch((error) => {
        setLoading(false);
        console.error('Device approval failed:', error);
        // 에러 처리 로직 추가 가능
      });
  }, [csSelected.host, id]); // 의존성 배열 수정

  return (
    <div className="device-approved-container">
      {loading ? (
        <div className="loading-container">
          <Spin size="large" />
        </div>
      ) : approved ? (
        <div className="success-container">
          <ToastSuccess />
          <p>
            <IntlMessages id="common.approvalSuccess"/>
          </p>
        </div>
      ) : (
        <div className="error-container">
          <p>
            <IntlMessages id="common.approvalFailed"/>
          </p>
        </div>
      )}
    </div>
  );
}

export default DeviceApproved;
